


















































































import { Component, Vue } from 'vue-property-decorator';
import firebase from 'firebase/app';
import * as firebaseui from 'firebaseui';
import { firebaseAuth } from '../../server/init';
import dealersDB from '../../server/init';
import slugify from 'slugify';
import axios from 'axios';

@Component({})

export default class DealerInquiry extends Vue {
  email: string = '';
  password: string = '';
  username: string | null = null;
  firstname: string | null = null;
  lastname: string | null = null;
  phone: string | null = null;
  company: string | null = null;
  address: string | null = null;
  zip: string | null = null;
  city: string | null = null;
  state: string | null = null;
  phoneType: string | null = null;
  phoneCode: string | null = null;
  lat: number | null = null;
  lng: number | null = null;
  investorType: string | null = null;
  usernameError: string | null = null;
  emailError: string | null = null;
  passwordError: string | null = null;
  firstnameError: string | null = null;
  lastnameError: string | null = null;
  phoneError: string | null = null;
  companyError: string | null = null;
  addressError: string | null = null;
  zipError: string | null = null;
  slugUser: string | null = null;
  formValid: boolean = false;
  submitted: boolean = false;
  showForm: boolean = false;
  formClosed: boolean = true;

  closeForm() {
    this.$emit('close-form');
    this.formClosed = true;
    this.showForm = false;
  }

  openForm() {
    this.showForm = true;
    this.formClosed = false;
    this.$emit('open-form');
  }

  validateForm() {
    this.validateZip();
    this.validateEmail();
    this.validatePhone();
    if (!this.email) {
      this.emailError = 'Please enter a valid email.';
    } else {
      this.emailError = null;
    }
    if (!this.username) {
      this.usernameError = 'Please enter a username.';
    } else {
      this.usernameError = null || '';
    }
    if (!this.password || this.password.length < 6) {
      this.passwordError = 'Please enter a password that is at least 6 characters.';
    } else {
      this.passwordError = null || '';
    }
    if (!this.firstname) {
      this.firstnameError = 'Please enter your first name.';
    } else {
      this.firstnameError = null || '';
    }
    if (!this.lastname) {
      this.lastnameError = 'Please enter your last name.';
    } else {
      this.lastnameError = null || '';
    }
    if (!this.company) {
      this.companyError = 'Please enter the name of your company.';
    } else {
      this.companyError = null || '';
    }
    if (!this.address) {
      this.addressError = 'Please enter the street address for your company.';
    } else {
      this.addressError = null || '';
    }
    return true;
  }



  validateZip() {
    const req = `https://us-zipcode.api.smartystreets.com/lookup?&key=1039832244004341&zipcode=${this.zip}`;
    axios.get(req)
    .then((response) => {
      const resCity = response.data[0].city_states[0];
      if (resCity.mailable_city === true) {
        this.zipError = null;
        this.city = resCity.city;
        this.state = resCity.state;
        this.getLatLng();
      }
    })
    .catch((e) => {
      this.zipError = 'Please enter a valid zipcode.';
      this.formValid = false;
    });
  }

  validatePhone() {
    const req = `http://apilayer.net/api/validate?access_key=25f34ea7d733d3b90c026094d33c167e&number=${this.phone}&country_code=US&format=1`;
    axios.get(req)
    .then((response) => {
      if (response.data.valid === true) {
        this.phone = response.data.local_format;
        this.phoneType = response.data.line_type;
        this.phoneCode = response.data.country_code;
        this.phoneError = null;
      } else {
        this.phoneError = 'Please enter a valid phone number with area code (U.S. Only).';
        this.formValid = false;
      }
    })
    .catch((e) => {
      console.log('phone error', e);
    });
  }

  validateEmail() {
    const req = `http://apilayer.net/api/check?access_key=a75a3fbd530c74ac99b2d8c6b10568e5&email=${this.email}&smtp=1&format=1`;
    axios.get(req)
    .then((response) => {
      const res = response.data;
      if (res.format_valid === true && res.mx_found === true && res.smtp_check === true) {
        this.email = res.email;
        this.emailError = null;
      } else {
        this.emailError = 'Please enter a valid email address.';
        this.formValid = false;
      }
    })
    .catch((e) => {
      console.log('email error', e);
    });
  }

  getLatLng() {
    const res = `https://maps.googleapis.com/maps/api/geocode/json?address=${this.address},${this.city},${this.state}&key=AIzaSyD7Zf02g4WeaGlggzvd9hme0iehGiro6Wg`;
    axios.get(res).then((response) => {
      if (response.data.error_message) {
        this.addressError = response.data.error_message;
      } else {
        this.lat = response.data.results[0].geometry.location.lat;
        this.lng = response.data.results[0].geometry.location.lng;
      }
    })
    .catch((error) => {
      this.addressError = error.message;

    });
  }



  signup() {
  this.validateForm();
  if (this.username && this.password && this.email) {
    this.slugUser = slugify(this.username, {
    replacement: '-',
    remove: /[$*_+~.()'"!\-:@#]/g,
    lower: true,
    });
    const ref = dealersDB.collection('dealers').doc(this.slugUser);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.usernameError = 'Sorry this username is already taken. Please choose a different username.';
      } else {
        firebaseAuth.createUserWithEmailAndPassword(this.email, this.password)
        .then((cred) => {
          ref.set({
            username: this.username,
            user_id: cred.user.uid,
            email: this.email,
            firstname: this.firstname,
            lastname: this.lastname,
            phone: this.phone,
            phoneType: this.phoneType,
            phoneCode: this.phoneCode,
            company: this.company,
            address: this.address,
            city: this.city,
            state: this.state,
            lat: this.lat,
            lng: this.lng,
            published: false,
            dealer: true,
            pendingDealer: true,
          })
          .then(() => {
            this.submitted = true;
          });
        })
        .catch((err) => {
          this.emailError = err.message;
        });
      }
    });
  }
  }
}
